import { c as _c } from "react/compiler-runtime";
import CustomTooltip from "@/components/utils/tooltip/CustomTooltip";
import { useId } from "react";
interface XtdhStatCardProps {
  readonly label: string;
  readonly value: string;
  readonly subtext?: string | undefined;
  readonly tooltip?: string | undefined;
  readonly onClick?: (() => void) | undefined;
}
export function XtdhStatCard(t0) {
  const $ = _c(21);
  const {
    label,
    value,
    subtext,
    tooltip,
    onClick
  } = t0;
  const tooltipDescriptionId = useId();
  let t1;
  if ($[0] !== label) {
    t1 = <div className="tw-text-[10px] tw-font-medium tw-uppercase tw-tracking-wider tw-text-iron-400 tw-mb-1">{label}</div>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const LabelContent = t1;
  let t2;
  if ($[2] !== onClick) {
    t2 = onClick && <button onClick={onClick} className="tw-absolute tw-top-3 tw-right-3 tw-flex tw-h-6 tw-w-6 tw-items-center tw-justify-center tw-rounded-full tw-bg-primary-500 tw-text-white hover:tw-bg-primary-400 tw-transition-colors tw-border-none tw-cursor-pointer" title="Action" type="button"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="tw-w-4 tw-h-4"><path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" /></svg></button>;
    $[2] = onClick;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== LabelContent || $[5] !== tooltip || $[6] !== tooltipDescriptionId) {
    t3 = tooltip ? <CustomTooltip content={<span aria-hidden="true">{tooltip}</span>} placement="top"><span aria-describedby={tooltipDescriptionId}>{LabelContent}<span id={tooltipDescriptionId} className="tw-sr-only">{tooltip}</span></span></CustomTooltip> : LabelContent;
    $[4] = LabelContent;
    $[5] = tooltip;
    $[6] = tooltipDescriptionId;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== value) {
    t4 = <span className="tw-text-xl tw-font-semibold tw-text-iron-50 tw-tabular-nums">{value}</span>;
    $[8] = value;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== subtext) {
    t5 = subtext && <span className="tw-text-xs tw-text-iron-500">{subtext}</span>;
    $[10] = subtext;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <div className="tw-flex tw-items-baseline tw-gap-1">{t4}{t5}</div>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t3 || $[16] !== t6) {
    t7 = <div className="tw-flex tw-flex-col">{t3}{t6}</div>;
    $[15] = t3;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t2 || $[19] !== t7) {
    t8 = <div className="tw-relative tw-rounded-xl tw-border tw-border-solid tw-border-iron-900 tw-bg-iron-950 tw-p-4">{t2}{t7}</div>;
    $[18] = t2;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}